import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { FontFamily } from '@/enums/index';
import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { Container } from '../core/Grid';

const ConferenecesContainer = styled(Container)<IThemeProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled.h2<IThemeProps>`
  font-family: ${FontFamily.SpaceGrotesk};
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.legacy.colors.blackActive};
  margin-bottom: 28px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) and (max-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 325px;
    text-align: center;
  }
`;

const ImageContainer = styled.div<IThemeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 160px;
  margin: 20px 8px;

  @media (min-width: ${BREAKPOINTS.Tablet.min}px) {
    min-width: 120px;
  }

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    min-width: 175px;
  }
`;

const ImagesContainer = styled.div<IThemeProps>`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 835px;

  @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
    max-width: 950px;
  }
`;

export const TopConferences = () => {
  const { t } = useTranslation();

  return (
    <ConferenecesContainer>
      <Title>{t('landing.conferencesTitle')}</Title>

      <ImagesContainer>
        <ImageContainer>
          <img css={{ width: 73 }} src="/images/landing/conferences/aaai.png" alt="aaai" />
        </ImageContainer>
        <ImageContainer>
          <img css={{ width: 160 }} src="/images/landing/conferences/aamas.png" alt="AAMAS2022" />
        </ImageContainer>
        <ImageContainer>
          <img css={{ width: 81 }} src="/images/landing/conferences/aapt.png" alt="AAPT" />
        </ImageContainer>
        <ImageContainer>
          <img css={{ width: 169 }} src="/images/landing/conferences/ecai.png" alt="ECAI" />
        </ImageContainer>
        <ImageContainer>
          <img css={{ width: 110 }} src="/images/landing/conferences/hvomp.png" alt="HVOMP" />
        </ImageContainer>
        <ImageContainer>
          <img css={{ width: 110 }} src="/src/assets/images/logos/ieee.png" alt="IEEE" />
        </ImageContainer>
        <ImageContainer>
          <img css={{ width: 109 }} src="/images/landing/conferences/mrs.png" alt="MRS" />
        </ImageContainer>
      </ImagesContainer>
    </ConferenecesContainer>
  );
};
